import { get } from '../helpers/fetchServicesMethods';
import { toast } from 'react-toastify';
import { url } from '../reducers/url';
import PubSub from 'pubsub-js';

function showLoader() {
    PubSub.publish('msg', true);
}

function hideLoader() {
    PubSub.publish('msg', false);
}

async function getBrowseData(id, sort, nocache, start, stop) {

    let apiurl = url.browseDatabase;

    try {
        apiurl = apiurl.replace(":id:", id);
        apiurl = apiurl.replace(":ST:", sort);
        apiurl = apiurl.replace(":NC:", nocache);
        apiurl = apiurl.replace(":S1:", start);
        apiurl = apiurl.replace(":S2:", stop);

    } catch (error) {
        console.error(error);
    }

    try {

        return await get(apiurl)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                toast.error('Failed to retrieve progress');
                console.log("error::", error);

            });
    } catch (error) {
        console.error(error);
    }

}
async function deletePerData(data, count) {
    let apiurl = '';
    try {
        const idData = data.join("%2C");
        if (data && count) {
            if (count === 1) {
                apiurl = 'do=gqshareable.delete&format=json&id=' + data[0] + '%2C&is_recursive=true';

            } else {

                let apiurls = 'do=gqshareable.delete&is_recursive=true&format=json&id=';
                let dataMapping = [];             
                data.forEach(item => {
                    ;                
                    const renamedUrl = item + '%2C';
                    dataMapping.push(renamedUrl);

                });
                let combineUrl = dataMapping.join('');
                apiurl = apiurls + combineUrl;
          
            }


        }      
        return await get(apiurl)

            .then((response) => {           
                return response;
            })
            .catch((error) => {            
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error);
        console.error(error, "errors");
    }
}

async function mergeBrowseDatabase(text_label, description, db, parent_folder_id, history){
        //mergeBrowseDatabase: "text_label=**&description=##&do=gqvfetch.create&db=@@&persist=1&parent_folder_id=%%&format=json",
    try{
        let mergeBrowseDB = url.mergeBrowseDatabase
        const formattedDb = `id:${db}`;
        mergeBrowseDB = mergeBrowseDB.replace('**',encodeURIComponent(text_label));
        mergeBrowseDB = mergeBrowseDB.replace('##',encodeURIComponent(description));
        mergeBrowseDB = mergeBrowseDB.replace('@@', encodeURIComponent(formattedDb));
        mergeBrowseDB = mergeBrowseDB.replace('%%', parent_folder_id);

        let urlParam = mergeBrowseDB;
        showLoader();
        return await get(urlParam, history)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                //toast.error('A');
                console.log("error::", error);
            });
    } catch (error) {
        hideLoader();
        console.error(error);
    }
}
 
const BrowseDatabaseServices = {
    getBrowseData,
    deletePerData,
    mergeBrowseDatabase,
    // getBrowseDatabase,
};

export default BrowseDatabaseServices;